import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IReligion {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  christian?: number | null;
  buddhist?: number | null;
  hindu?: number | null;
  jewish?: number | null;
  muslim?: number | null;
  sikh?: number | null;
  otherReligion?: number | null;
  noReligion?: number | null;
  religionNotStated?: number | null;
}

export const defaultValue: Readonly<IReligion> = {};
